import { Box } from "@mui/material";
import styled from "styled-components";

export const UpdatePasswordStyled = styled(Box)`
  padding: 56px;

  .back {
    display: flex;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    p {
      font-size: 12px;
    }
  }

  .container {
    width: 548px;
    .title {
      font-weight: 600;
      font-size: 36px;
      color: var(--dark-gray-color);
      margin-bottom: 32px;
    }
    .buttons-container {
      margin-top: 32px;
      .primary-button {
        display: flex;
      }
    }
  }

  .flex {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
`;
